import { AppState } from 'store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { Popup } from 'components/Common/op-ui-wrappers/OpPopup/OpPopup';

const removePopupReducer = (state: AppState, action: PayloadAction<Popup>) => {
  state.popups = [...state.popups, action.payload];
};

export default removePopupReducer;
